export default {"src":"/_next/static/media/empty-search-dark.817d7971.svg","height":100,"width":100};